// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_8r6Jq","more":"more_D6-wi","g-icon":"g-icon","iconfont":"iconfont","g-text":"g-text","product":"product_XOD-x"};